const AddFixtureButton = () => import('../../components/add-fixture-button/index.vue');

export default {
    name: 'FixturesPage',
    
    components: {
        'add-fixture-button': AddFixtureButton
    },

    data() {
        return {
            list: []
        };
    }, 

    computed: {
        fixtures_list() {
            return this.$store.state.fixtures.fixtures_list;
        },
        subscription() {
            return this.$store.getters.getActiveSubscription;
        }
    },

    watch: {
        fixtures_list: 'setList'
    },

    created() {
        this.setList();
        this.$store.commit('setMenuDetails', { title: 'Fixtures', slug: 'fixtures', back_url: '/action/operations' });
    },

    methods: {
        setList() {
            const list = this.$store.getters.getFixturesList
            this.$store.commit('setMenuItems', list);
            this.list = list;
        },
    }
};